// extracted by mini-css-extract-plugin
export default {"adyen":"VaoJTGTRikBQmtDjvnlK"};